// @ts-nocheck
import React, { useState } from "react";
import { styled } from '@mui/material/styles';
import SinapTheme from "../styles/SinapTheme";
import CircularIndeterminate from "../Componentes/CircularIndeterminate";
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { forwardRef } from 'react';
import Clear from '@mui/icons-material/Clear';
import Search from '@mui/icons-material/Search';
import ModalVerRecibo from "./ModalVerRecibo";
import AddBox from '@mui/icons-material/AddBox';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import Check from '@mui/icons-material/Check';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import Edit from '@mui/icons-material/Edit';
import FilterList from '@mui/icons-material/FilterList';
import FirstPage from '@mui/icons-material/FirstPage';
import LastPage from '@mui/icons-material/LastPage';
import Remove from '@mui/icons-material/Remove';
import SaveAlt from '@mui/icons-material/SaveAlt';
import ViewColumn from '@mui/icons-material/ViewColumn';
import Tabla from "../Componentes/Tabla";
import { TiempoRestante } from "../Usuarios/Componentes/TiempoRestante";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import KeyCloak from "../Auth/Keycloak";
import { Edit as EditIcon } from '@mui/icons-material';
import Tooltip from "@mui/material/Tooltip";


const Root = styled('div')(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        marginLeft: '-10%',
        padding: '0 0',
    },
    [theme.breakpoints.down('lg')]: {
        margin: 'auto',
        widht: '70%'
    }
}));

const Posiciontabla = styled('div')(({ theme }) => ({
    width: '100%',
    [theme.breakpoints.down('md')]: {
        position: 'relative',
        width: 'auto',
        marginLeft: 'auto'
    }
}));

export const DownloadIcono = styled(DownloadIcon)(({ theme }) => ({
    color: theme.palette.secondary.main,

}));

const ViewIcon = styled(VisibilityIcon)(({ theme }) => ({
    color: theme.palette.secondary.main,
}));



export default function RecibosTable({ recibos, load, downloadRecibo }) {
    const [reciboSeleccionado, setReciboSeleccionado] = useState(false);
    const [openModalRecibo, setOpenModalRecibo] = useState(false);

    const verRecibo = (recibo) => {
        setReciboSeleccionado(recibo)
        setOpenModalRecibo(true);
    }

    const actions = [];

    actions.push({
        icon: DownloadIcono,
        tooltip: 'Descargar recibo',
        onClick: (event, rowData) => downloadRecibo(rowData)
    });

    actions.push({
        icon: ViewIcon,
        tooltip: 'Ver recibo',
        onClick: (event, rowData) => verRecibo(rowData)
    });

    const columns = React.useMemo(() =>
        [
            {

                accessorKey: 'name_for_client',

                header: 'Nombre',


            },
        ])


    return (
        <Root>
            <Posiciontabla>
                {load ?
                    <CircularIndeterminate />
                    :
                    <>
                        <ModalVerRecibo downloadRecibos={() => downloadRecibo(reciboSeleccionado)} open={openModalRecibo} onClose={() => setOpenModalRecibo(false)} recibo={reciboSeleccionado} />
                        <Tabla
                            columns={columns}
                            data={recibos}

                            enableRowActions

                            positionActionsColumn='last'

                            renderRowActions={({ row, table }) => (

                                <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>

                                    <IconButton

                                        color="secondary"

                                        onClick={() => {

                                            downloadRecibo(row.original)

                                        }}

                                    >
                                        <Tooltip title={'Descargar Recibo'}>
                                            <DownloadIcono />
                                        </Tooltip>

                                    </IconButton>

                                    <IconButton

                                        color="secondary"

                                        onClick={() => {

                                            verRecibo(row.original)

                                        }}

                                    >

                                        <Tooltip title={'Visualizar Recibo'}>
                                            <ViewIcon />
                                        </Tooltip>

                                    </IconButton>

                                </Box>

                            )}
                        />

                    </>
                }
            </Posiciontabla>
        </Root>
    )
}